import type { LocationDescriptor } from 'history';
import type { MouseEventHandler } from 'react';

export interface LoginFormValues {
  email: string;
  password: string;
}

export interface LoginFormData {
  form: {
    initialValues: LoginFormValues;
    onSubmit: (value: LoginFormValues) => void;
    validationSchema: any;
  };
  onGoogleClick?: MouseEventHandler;
  onFacebookClick?: MouseEventHandler;
  onForgotPasswordClick?: () => void;
  loading?: boolean;
  joinLink?: LocationDescriptor;
}

export interface LoginFormProps extends LoginFormData {}
